
function handleSpecialCartItem() {
  const variantIds = [
  "50944714703081",
  "50944713392361",
  "50944645234921"
  ];

variantIds.forEach(variantId => {
  const inputs = document.querySelectorAll(
    `[data-quantity-variant-id="${variantId}"]`
  );

  inputs.forEach(input => {
    const row = input.closest('tr, .cart-item');

    if (!row) return;

    row.style.pointerEvents = 'none';
    row.style.opacity = '0.9';
    row.classList.add('free-item');

    const title = row.querySelector('.cart-item__details');
    const quantity = row.querySelector('.cart-item__quantity');
 if (quantity) {
  quantity.innerHTML = ''; 

  const label = document.createElement('div');
  label.className = 'eofy-free-label';
  label.textContent = 'Free EOFY Pack Added';

  const name = title.querySelector('.cart-item__name');

if (name && !title.querySelector('.eofy-free-label')) {
  title.insertBefore(label, name);
}
}
  });
  });
}

document.addEventListener('DOMContentLoaded', handleSpecialCartItem);

const observer = new MutationObserver(handleSpecialCartItem);
observer.observe(document.body, {
  childList: true,
  subtree: true
});
